module.exports = __webpack_public_path__ + "static/media/modern.f5269fef.webp";